import {
  GAME_DASHBOARD_CARD_CREATE_REQUEST,
  GAME_DASHBOARD_CARD_CREATE_REQUEST_SUCCESS,
  GAME_DASHBOARD_CARD_CREATE_REQUEST_ERROR, UPDATE_ACTIVE_OVERLAY_ID,
  UPDATE_OPEN_SITUATION_ID, SHOWBLUR_IMAGE, UPDATE_OPEN_SITUATION_ARRAY
} from "../actionTypes/type";

export const gameDashboardCardCreateRequest = (paramsData, onSuccess, onError) => {
  return {
    type: GAME_DASHBOARD_CARD_CREATE_REQUEST,
    params: paramsData,
    onSuccess,
    onError
  };
};

export const actionSuccess = (result) => {
  return {
    type: GAME_DASHBOARD_CARD_CREATE_REQUEST_SUCCESS,
    payload: result,
    error: null
  };
};

export const actionError = (error) => {
  return {
    type: GAME_DASHBOARD_CARD_CREATE_REQUEST_ERROR,
    error: error,
    payload: null,
  };
};


export const actionOverlayId = (paramsData) => {
  return {
    type: UPDATE_ACTIVE_OVERLAY_ID,
    payload: paramsData,
    error: null
  };
};

export const actionOpenSituationArray = (paramsData) => {
  return {
    type: UPDATE_OPEN_SITUATION_ARRAY,
    payload: paramsData,
    error: null
  };
};


export const actionOpenSituationId = (paramsData) => {
  return {
    type: UPDATE_OPEN_SITUATION_ID,
    payload: paramsData,
    error: null
  };
};